import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import {
  getDoctors,
  createDoctor,
  getDoctorById,
  addDoctorMedia,
  deleteDoctor,
  updateDoctor,
  updateDoctorSchedule,
} from "../api/doctors"

export const useFetchDoctors = (offset, limit, search) => {
  return useQuery({
    queryKey: ["doctors", offset, limit, search],
    queryFn: async () => {
      const res = await getDoctors({ offset, limit, search })
      return res.data
    },
    select: (response) => ({
      doctors: response.data.doctors,
      pagination: {
        total: response.data.total,
        totalPages: Math.ceil(response.data.total / limit),
      },
    }),
    staleTime: 5 * 60 * 1000,
  })
}

export const useCreateDoctor = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data) => createDoctor(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["doctors"] })
    },
  })
}

export const useGetDoctorById = (id) => {
  return useQuery({
    queryKey: ["doctor", id],
    queryFn: () => getDoctorById(id),
    select: (response) => response.data.data,
    enabled: !!id,
  })
}

export const useAddDoctorMedia = (doctorId) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data) => addDoctorMedia(doctorId, data),
    onSuccess: () => {
      // Invalidate doctor details to refresh media list
      queryClient.invalidateQueries(["doctor", doctorId])
    },
  })
}

export const useDeleteDoctor = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id) => deleteDoctor(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["doctors"] })
    },
  })
}

export const useUpdateDoctor = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }) => updateDoctor(id, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["doctor", variables.id],
        exact: true,
      })
    },
  })
}

export const useUpdateDoctorSchedule = (doctorId) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data) => updateDoctorSchedule(doctorId, data),
    onSuccess: () => {
      queryClient.invalidateQueries(["doctor", doctorId])
    },
  })
}
